import CONSTANT from "../../constants/Constant";
import React from "react";
import StepBar from "../shared/stepbar/StepBar";
import { useSelector } from "react-redux";
import EditAssessmentQuestionContainer from "./EditAssessmentQuestionContainer";
import EditAssessmentQuestionTab from "./EditAssessmentQuestionTab";
import EditAssessmentQuestionFooter from "./EditAssessmentQuestionFooter";
import './EditAssessmentQuestionBody.scss';

const EditAssessmentQuestionBody = ({ setSelectedElementForScroll }) => {
    const editAssessmentGroup = useSelector(state => state.editAssessment);
    const groups = editAssessmentGroup?.groups;

    const baseData = editAssessmentGroup?.baseData || {};
    const currentGroupId = baseData?.currentGroupId || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;


    return (
        <div className="edit-assessment-question-body__container">
            <div className="edit-assessment-question-body__container-inner">
                <div className="edit-assessment-question-body__stepbar-container">
                    <StepBar groups={groups} showName={false} />
                </div>

                <EditAssessmentQuestionTab />

                <div className="edit-assessment-question-body__portlet">
                    <div className="edit-assessment-question-body__portlet-body--fit">
                        <div className="edit-assessment-question-body__grid">
                            <div className="edit-assessment-question-body__grid__item--fluid edit-assessment-question-body__wrapper">
                                <div className="edit-assessment-question-body__form" noValidate="novalidate">
                                    {currentGroupId && (
                                        <EditAssessmentQuestionContainer
                                            setSelectedElementForScroll={setSelectedElementForScroll}
                                        />
                                    )}
                                    <EditAssessmentQuestionFooter />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditAssessmentQuestionBody;